<template>
  <div>
    <div>
      <medication-fluid-selector
        :selected="state.selectedMedication || state.selectedFluid"
        :case-conf="emitter.caseConf"
        :medications="medications"
        :disabled="readonly"
        :dosage-form-filter="
          dosageForm => dosageForm.enabledRoutes.find(r => r.key === 'IV_IO_INFUSION')
        "
        @select="
          (treatmentType, treatmentId) => {
            if (treatmentType === 'MEDICATION') {
              selectMedication(treatmentId);
            } else if (treatmentType === 'FLUID') {
              selectFluid(treatmentId);
            }
          }
        "
      />
      <help-tooltip v-if="!(state.selectedMedication || state.selectedFluid)" type="warning">
        An option must be selected. Data will not be saved.
      </help-tooltip>
      <help-tooltip v-if="hasMedicationError" type="error">
        <span v-for="error in medicationErrors" :key="error.message">{{ error.message }}<br></span>
      </help-tooltip>
    </div>
    <el-select
      v-close-on-zoom
      :value="state.selectedActions || []"
      :disabled="readonly"
      placeholder="Any"
      :default-first-option="true"
      class="actions-select"
      multiple
      @input="actions => selectActions(actions)"
    >
      <el-option label="Initiated" value="ADMINISTERED" />
      <el-option label="Disconnected" value="DISCONNECTED" />
      <el-option label="Paused" value="PAUSED" />
      <el-option label="Resumed" value="RESUMED" />
      <el-option label="Clamp Main Tubing" value="CLAMP_FULL_PAUSED" />
      <el-option label="Unclamp Main Tubing" value="CLAMP_FULL_RESUMED" />
      <el-option label="Titrated" value="CHANGED" />
    </el-select>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import HelpTooltip from '~lib/common/components/HelpTooltip';
import MedicationFluidSelector from './common/MedicationFluidSelector';

export default {
  name: 'infusion-action',
  components: {
    HelpTooltip,
    MedicationFluidSelector,
  },
  props: [
    'medications',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        selectedMedication: null,
        selectedFluid: null,
        selectedActions: null,
      },
    };
  },
  computed: {
    errors() {
      if (!this.emitter.$staore) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
    medicationErrors() {
      return this.errors.filter(error => !error.metadata.routeId);
    },
    routeErrors() {
      return this.errors.filter(error => error.metadata.routeId);
    },
    hasMedicationError() {
      return !!this.medicationErrors.length;
    },
    hasRouteError() {
      return !!this.routeErrors.length;
    },
  },
  beforeMount() {
    const data = this.getData(this.ikey);
    this.state.selectedType = get(data, 'type') === 'INFUSION_MEDICATION' ? 'MEDICATION' : 'FLUID';
    this.state.selectedMedication = this.state.selectedType === 'MEDICATION' ? get(data, 'id') || null : null;
    this.state.selectedFluid = this.state.selectedType === 'FLUID' ? get(data, 'id') || null : null;
    this.state.selectedActions = get(data, 'actions') || null;
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectMedication(medicationId) {
      this.state.selectedMedication = medicationId;
      this.state.selectedFluid = null;
      this.state.selectedType = 'MEDICATION';
      this.update();
    },
    selectFluid(fluidId) {
      this.state.selectedFluid = fluidId;
      this.state.selectedMedication = null;
      this.state.selectedType = 'FLUID';
      this.update();
    },
    selectActions(actions) {
      this.state.selectedActions = actions;
      this.update();
    },
    update() {
      const { selectedMedication, selectedFluid, selectedType, selectedActions } = this.state;
      this.putData(this.ikey, {
        type:
          selectedType === 'MEDICATION'
            ? 'INFUSION_MEDICATION'
            : 'INFUSION_FLUID',
        id: selectedMedication || selectedFluid,
        actions: selectedActions,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style>
.el-select.error {
  border: solid 3px #f92c2d;
}
</style>
